import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
  selector: 'app-header-separat',
  templateUrl: './header-separat.component.html',
  styleUrls: ['./header-separat.component.scss']
})
export class HeaderSeparatComponent implements OnInit {

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
  }

  classApplied = false;
  toggleClass() {
      this.classApplied = !this.classApplied;
  }

  classApplied2 = false;
  toggleClass2() {
      this.classApplied2 = !this.classApplied2;
  }

  classApplied3 = false;
  toggleClass3() {
      this.classApplied3 = !this.classApplied3;
  }


  isLogged() {
    const t = this;

    return  this.authService.isAuthenticated();

}
}
